import {
  ISendNotification,
  ISendNotificationModelBody,
} from "../../utils/types";
import { apiManager } from "../api-manager";

export const sendNotifications = async (body: ISendNotificationModelBody) => {
  const res = await apiManager.post<ISendNotification>(
    "/admin/notifications",
    body
  );
  return res;
};
